import React from 'react';

import LandingPage from "../views/LandingPage/LandingPage";
import ProjectsPage from "../views/LandingPage/pages/ProjectsPage";
import ProjectPage from "../views/LandingPage/pages/ProjectPage";
import SpeakerPage from "../views/LandingPage/pages/SpeakerPage";

var indexRoutes = [
    // { path: "/components", name: "Components", component: Components},
    {path: process.env.PUBLIC_URL + "/projects/:id", name: "ProjectPage", component: ProjectPage},
    {path: process.env.PUBLIC_URL + "/projects", name: "ProjectsPage", component: ProjectsPage},
    {path: process.env.PUBLIC_URL + "/speaker", name: "SpeakersPage", component: SpeakerPage},
    {path: process.env.PUBLIC_URL + "/", name: "LandingPage", component: LandingPage},
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/routes.jsx